// Pass details as props about the current brand
var getBrand = function getBrand() {
  var law = {
    id: 'law',
    name: 'laithwaites',
    companyName: 'Direct Wines Limited',
    displayName: "Laithwaites",
    web: 'laithwaites.co.uk',
    telephone: '03330 148 168',
    wineplanTelephone: '03330 148 149',
    address: 'One Waterside Drive, Arlington Business Park, Theale, Berkshire, RG7 4SW',
    dpoEmail: 'dpo@laithwaites.co.uk',
    privacyUrl: '/customer-services/privacy-policy-and-cookies#contact-promise',
    termsUrl: '/customer-services/customer-terms-and-conditions-of-sale-and-use',
    cookiesUrl: '/customer-services/privacy-policy-and-cookies#cookies'
  };
  if (typeof window === 'undefined') {
    return law;
  }
  switch (window.location.hostname) {
    case 'www.averys.com':
    case 'preview.averys.com':
    case 'uat.averys.com':
    case 'ak.uat.averys.com':
    case 'st.averys.com':
    case 'ak.st.averys.com':
    case 'sun-st.averys.com':
    case 'webdev001.averys.com':
    case 'webdev002.averys.com':
    case 'webdev003.averys.com':
    case 'webdev009.averys.com':
    case 'webdev010.averys.com':
      return {
        id: 'avy',
        name: 'averys',
        companyName: 'Averys of Bristol Limited',
        displayName: 'Averys',
        web: 'averys.com',
        telephone: '03330 148 208',
        wineplanTelephone: '03330 148 212',
        address: '9A Culver Street, Bristol, BS1 5LD',
        dpoEmail: 'dpo@averys.com',
        privacyUrl: '/customer-services/privacy-policy-and-cookies',
        termsUrl: '/jsp/content.jsp?pg=privacytc&sec=general',
        cookiesUrl: '/customer-services/privacy-policy-and-cookies'
      };
      break;
    case 'www.sundaytimeswineclub.co.uk':
    case 'preview.sundaytimeswineclub.co.uk':
    case 'uat.sundaytimeswineclub.co.uk':
    case 'ak.uat.sundaytimeswineclub.co.uk':
    case 'st.sundaytimeswineclub.co.uk':
    case 'ak.st.sundaytimeswineclub.co.uk':
    case 'webdev001.sundaytimeswineclub.co.uk':
    case 'webdev002.sundaytimeswineclub.co.uk':
    case 'webdev003.sundaytimeswineclub.co.uk':
    case 'webdev009.sundaytimeswineclub.co.uk':
    case 'webdev010.sundaytimeswineclub.co.uk':
      return {
        id: 'stw',
        name: 'sundaytimes',
        companyName: 'Direct Wines Limited',
        displayName: 'The Sunday Times Wine Club',
        web: 'sundaytimeswineclub.co.uk',
        telephone: '03330 142 776',
        wineplanTelephone: '03330 148 149',
        address: 'One Waterside Drive, Arlington Business Park, Theale, Berkshire, RG7 4SW',
        dpoEmail: 'dpo@thesundaytimeswineclub.co.uk',
        privacyUrl: '/customer-services/privacy-policy-and-cookies#contact-promise',
        termsUrl: '/customer-services/terms-and-conditions-of-sale-and-use',
        cookiesUrl: '/customer-services/privacy-policy-and-cookies#cookies'
      };
      break;
    case 'www.bawineflyer.co.uk':
    case 'www.bawineclub.co.uk':
    case 'preview.bawineflyer.co.uk':
    case 'preview.bawineclub.co.uk':
    case 'uat.bawineflyer.co.uk':
    case 'uat.bawineclub.co.uk':
    case 'st.bawineflyer.co.uk':
    case 'st.bawineclub.co.uk':
    case 'webdev001.bawineclub.co.uk':
    case 'webdev002.bawineclub.co.uk':
    case 'webdev003.bawineclub.co.uk':
    case 'webdev001.bawineflyer.co.uk':
    case 'webdev002.bawineflyer.co.uk':
    case 'webdev003.bawineflyer.co.uk':
    case 'webdev009.bawineflyer.co.uk':
    case 'webdev010.bawineflyer.co.uk':
      return {
        id: 'ba',
        name: 'bawineflyer',
        companyName: 'Direct Wines Limited',
        displayName: 'The British Airways Wine Flyer',
        web: 'bawineflyer.co.uk',
        telephone: '03330 142 759',
        wineplanTelephone: '03330 148 149',
        address: 'One Waterside Drive, Arlington Business Park, Theale, Berkshire, RG7 4SW',
        dpoEmail: 'dpo@bawineflyer.co.uk',
        privacyUrl: '/customer-services/privacy-policy-and-cookies#contact-promise',
        termsUrl: '/customer-services/terms-and-conditions-of-sale-and-use',
        cookiesUrl: '/customer-services/privacy-policy-and-cookies#cookies'
      };
      break;
    case 'www.bbcgoodfoodwineclub.com':
    case 'preview.bbcgoodfoodwineclub.com':
    case 'uat.bbcgoodfoodwineclub.com':
    case 'ak.uat.bbcgoodfoodwineclub.com':
    case 'st.bbcgoodfoodwineclub.com':
    case 'ak.st.bbcgoodfoodwineclub.com':
    case 'webdev001.bbcgoodfoodwineclub.com':
    case 'webdev002.bbcgoodfoodwineclub.com':
    case 'webdev003.bbcgoodfoodwineclub.com':
    case 'webdev009.bbcgoodfoodwineclub.com':
    case 'webdev010.bbcgoodfoodwineclub.com':
      return {
        id: 'bbc',
        name: 'bbcgoodfood',
        companyName: 'Direct Wines Limited',
        displayName: 'Good Food Wine Club',
        web: 'goodfoodwineclub.com',
        telephone: '03300 242 855',
        wineplanTelephone: '03330 148 149',
        address: 'One Waterside Drive, Arlington Business Park, Theale, Berkshire, RG7 4SW',
        dpoEmail: 'dpo@goodfoodwineclub.com',
        privacyUrl: '/customer-services/privacy-policy-and-cookies#contact-promise',
        termsUrl: '/customer-services/customer-terms-and-conditions-of-sale-and-use',
        cookiesUrl: '/customer-services/privacy-policy-and-cookies#cookies'
      };
      break;
    // Old ulrs TODO: need to remove
    case 'www.laithwaiteshsbcwines.co.uk':
    case 'uat.laithwaiteshsbcwines.co.uk':
    case 'preview.laithwaiteshsbcwines.co.uk':
    case 'st.laithwaiteshsbcwines.co.uk':
    // New ulrs
    case 'winerewards.laithwaites.co.uk':
    case 'uat-winerewards.laithwaites.co.uk':
    case 'preview-winerewards.laithwaites.co.uk':
    case 'st-winerewards.laithwaites.co.uk':
    case 'webdev001.hsbcwines.co.uk':
    case 'webdev002.hsbcwines.co.uk':
    case 'webdev003.hsbcwines.co.uk':
    case 'webdev009.hsbcwines.co.uk':
    case 'webdev001.laithwaiteshsbcwines.co.uk':
    case 'webdev002.laithwaiteshsbcwines.co.uk':
    case 'webdev003.laithwaiteshsbcwines.co.uk':
    case 'webdev009.laithwaiteshsbcwines.co.uk':
    case 'webdev010.laithwaiteshsbcwines.co.uk':
    case 'webdev001-winerewards.laithwaites.co.uk':
    case 'webdev002-winerewards.laithwaites.co.uk':
    case 'webdev003-winerewards.laithwaites.co.uk':
    case 'webdev009-winerewards.laithwaites.co.uk':
    case 'webdev010-winerewards.laithwaites.co.uk':
    // Old ulrs TODO: need to remove
    case 'softlaunch.laithwaiteshsbcwines.co.uk':
    // New ulrs
    case 'soft-winerewards.laithwaites.co.uk':
      return {
        id: 'hsb',
        name: 'hsbcwines',
        companyName: 'Direct Wines Limited',
        displayName: 'HSBC Wines',
        web: 'laithwaiteshsbcwines.co.uk',
        telephone: '03330 148 174',
        wineplanTelephone: '03330 148 149',
        address: 'One Waterside Drive, Arlington Business Park, Theale, Berkshire, RG7 4SW',
        dpoEmail: 'dpo@laithwaiteshsbcwines.co.uk',
        privacyUrl: '/customer-services/privacy-policy-and-cookies#contact-promise',
        termsUrl: '/jsp/content.jsp?pg=privacy',
        cookiesUrl: '/customer-services/privacy-policy-and-cookies#cookies'
      };
      break;
    default:
      return law;
      break;
  }
};
export default getBrand;